
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/survey/aep/pharmacy",
      function () {
        return require("private-next-pages/account/survey/aep/pharmacy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/survey/aep/pharmacy"])
      });
    }
  